import type { BadgeProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import type {
  SectionHeaderProps} from '@/components/Section/SectionHeader'
import {
  SectionHeader
} from '@/components/Section/SectionHeader'
import { SectionHeading } from '@/components/Section/SectionHeading'

import { BadgeStep } from '../../components/ui/BadgeStep'

export interface FormSectionHeaderProps extends SectionHeaderProps {
  number?: number | ReactNode
  numberBadgeProps?: BadgeProps
}

export const FormSectionHeader = ({
  children,
  asHeading = true,
  number,
  numberBadgeProps,
  ...rest
}: FormSectionHeaderProps) => {
  return (
    <SectionHeader {...rest} asHeading={false}>
      {number && <BadgeStep {...numberBadgeProps}>{number}</BadgeStep>}

      {asHeading && <SectionHeading>{children}</SectionHeading>}

      {!asHeading && children}
    </SectionHeader>
  )
}
